export const COUNTRY_CODE_STORAGE_NAME = 'country_code'
export const USA_COUNTRY_CODE = 'US'
export const AUSTRALIA_COUNTRY_CODE = 'AU'
export const AU_CURRENCIES_TEXT = 'Bitcoin, Ethereum, Gold and Silver Standard'
export const US_CURRENCIES_TEXT = 'Bitcoin and Ethereum'
